<template>
  <div class="h-screen flex flex-col justify-between bg-white text-center px-4 pb-20">
    <div class="mt-30">
      <div class="flex justify-center">
        <NuxtImg class="w-screen max-w-[632px]" src="/images/components/404.jpg" loading="lazy" />
      </div>
      <h1 class="text-5xl font-bold text-black mb-4">Oops!</h1>
      <p class="text-gray-500 text-xl md:text-2xl mb-6">
        {{ errorDict[error?.statusCode] || error?.message || 'Unexpected error occurred.' }}
      </p>
    </div>
    <div class="w-full flex justify-center">
      <NuxtLink to="/" class="bg-green-300 text-black font-light text-xl border-none rounded-4xl w-full max-w-[471px] py-5 text-center">
        ← Go back
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { NuxtImg } from '#components';
defineProps({
  error: Object
})
const errorDict = {
  404: 'We couldn’t find the page yor were looking for.',
  403: 'You are not authorized to access this page.',
  500: 'Internal server error. Please try again later.',
  400: 'Bad request. Something went wrong.',
}
</script>

<style lang="scss" scoped></style>